import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import SessionWarningDialog from '../auth/SessionWarningDialog';
import './layout.scss';
const COMPACT_NAV_QUERY = '(max-width: 1600px)';
export default function AppLayout() {
    const [collapsed, setCollapsed] = useState(window.innerWidth <= 1024);
    const [compactNav, setCompactNav] = useState(() => window.matchMedia(COMPACT_NAV_QUERY).matches);
    useEffect(() => {
        const mq = window.matchMedia(COMPACT_NAV_QUERY);
        const onChange = (e) => setCompactNav(e.matches);
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, []);
    const sidebarWidth = collapsed ? 64 : compactNav ? 210 : 255.99;
    return (_jsxs("div", { className: `app-layout ${collapsed ? 'sidebar-collapsed' : ''}`, children: [_jsx(Sidebar, { collapsed: collapsed }), _jsx("button", { className: "sidebar-toggle", style: { left: `${sidebarWidth - 12}px` }, onClick: () => setCollapsed(!collapsed), children: _jsx("i", { className: `pi ${collapsed ? 'pi-chevron-right' : 'pi-chevron-left'}` }) }), _jsxs("div", { className: "main-wrapper", children: [_jsx(Header, {}), _jsx("main", { className: "page-content", children: _jsx(Outlet, {}) })] }), _jsx(SessionWarningDialog, {})] }));
}
